/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Box } from 'grommet';
import { AlertBar } from 'blb-components/GrommetComponents';

const TeamsPageErrorState: React.FC<{ error: Error }> = ({ error }) => {
  const errorMessage = `There was an error while retrieving your teams. Please refresh and try again: ${error.message}`;
  return (
    <Box align="center" flex="grow">
      <AlertBar errorMessage={errorMessage} id="teams-page-error" />
    </Box>
  );
};

export default TeamsPageErrorState;
